import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Quote from "./pages/Quote";
import Deposit from "./pages/Deposit";
import Retainer from "./pages/Retainer";
import Pricing from "./pages/Pricing";
import OneOff from "./pages/OneOff";
import Audit from "./pages/Audit";
import About from "./pages/About";
import PaymentSuccess from "./pages/PaymentSuccess";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Reel from "./pages/Reel";
import Contact from "./pages/Contact";
import WhyBespoke from "./pages/WhyBespoke";
import Process from "./pages/Process";
import DiWater from "./pages/DiWater";
import Industries from "./pages/Industries";
import Gallery from "./pages/Gallery";
import Referral from "./pages/Referral";
import Learning from "./pages/Learning";
import LearningArticle from "./pages/LearningArticle";
import FoundingPartner from "./pages/FoundingPartner";
import ChatWidget from "./components/ChatWidget";
import CustomCursor from "./components/CustomCursor";
import PageTransition from "./components/PageTransition";
import IntroReveal from "./components/IntroReveal";
import SoundToggle from "./components/SoundToggle";
import CinemaToggle from "./components/CinemaToggle";
import MouseFollowLight from "./components/MouseFollowLight";
import PersistentCTA from "./components/PersistentCTA";
import ActionRail from "./components/ActionRail";
import SiteWalkTrigger from "./components/SiteWalkTrigger";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollProgressBar from "./components/ScrollProgressBar";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <ScrollProgressBar />
          <IntroReveal />
          <CustomCursor />
          <MouseFollowLight />
          <SoundToggle />
          <CinemaToggle />
          <Layout>
            <PageTransition>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/quote" element={<Quote />} />
                <Route path="/deposit" element={<Deposit />} />
                <Route path="/retainer" element={<Retainer />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/one-off" element={<OneOff />} />
                <Route path="/audit" element={<Audit />} />
                <Route path="/about" element={<About />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/login" element={<Login />} />
                <Route path="/reel" element={<Reel />} />
                <Route path="/why" element={<WhyBespoke />} />
                <Route path="/process" element={<Process />} />
                <Route path="/di-water" element={<DiWater />} />
                <Route path="/industries" element={<Industries />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/referral" element={<Referral />} />
                <Route path="/learn" element={<Learning />} />
                <Route path="/learn/:slug" element={<LearningArticle />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/founding-partner" element={<FoundingPartner />} />
                <Route path="/founding" element={<FoundingPartner />} />
                <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              </Routes>
            </PageTransition>
            <Footer />
            <ChatWidget />
            <ActionRail />
            <PersistentCTA />
            <SiteWalkTrigger />
          </Layout>
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="bottom-left" />
    </div>
  );
}

export default App;
